module.exports = __webpack_public_path__ + "img/Wp_2044.0171fa74.png";